@import (reference) '../../../constants/spacing.module.less';

@sparkle-icon-color: var(--gold-400);

.rate-comparison-wrapper {
  width: 100%;
  flex-flow: row;
  gap: @space-8;
  align-items: center;
  justify-content: space-between;
}

.rate-comparison-apply-button {
  min-width: 75px;
  width: max-content;
  background: var(--default--background-color--14);
  color: var(--default--text-color--18);
}

.recommendation-wrapper {
  flex-flow: row nowrap;
  padding: @space-8;
  gap: @space-8;
  border-radius: 4px;
}

.recommendation-content-wrapper {
  flex: 1;
  display: flex;
  flex-flow: row nowrap;
  gap: @space-4;
}

.single-recommendation-banner-content {
  align-items: center;
}

.recommendation-wrapper-dark {
  color: var(--default--text-color--21);
  background: var(--fulfillment-plans-rate-recommendation--background-color-dark);
  border: 1px solid var(--fulfillment-plans-rate-recommendation--border-color-dark);
}

.recommendation-wrapper-medium {
  border: 1px solid var(--default--background-color-21);
  background: var(--default--background-color-21);
  color: var(--light--text-color--1);
}

.recommendation-wrapper-light {
  color: var(--default--text-color--17);
  background: var(--fulfillment-plans-rate-recommendation--background-color-light);
  border: 1px solid var(--fulfillment-plans-rate-recommendation--border-color-light);
}

.recommendation-close-button {
  &:enabled {
    &:hover {
      background: none;
    }

    &:active {
      background: none;
    }
  }
}

.recommendation-close-button-medium,
.recommendation-close-button-dark {
  color: var(--default--background-color--13);
}

.recommendation-close-button-light {
  color: var(--default--background-color--17);
}

.recommendation-banner-icon-container {
  container-type: size;
  flex: 0 0 24px;
  display: flex;
  flex-flow: column nowrap;
}

.recommendation-banner-sparkle-icon {
  color: @sparkle-icon-color;
  height: 24px;
  width: 24px;
  flex: 0 0 auto;

  // When banner contains more than 1 line of text (causing height > 24px), add margin to align icon with first line of text
  @container (height > 24px) {
    margin-top: 4px;
  }
}

.savings-icon {
  display: flex;
  width: 16px;
  height: 16px;
  color: @sparkle-icon-color;
}

.savings-icon-enabled {
  color: @sparkle-icon-color;
  &:hover {
    cursor: pointer;
    background: var(--grey-300);
  }
}

.savings-icon-disabled {
  color: var(--grey-400);
  &:hover {
    cursor: no-drop;
  }
}

.alternative-rate-tooltip-title {
  display: flex;
  align-items: center;
  gap: @space-8;
  justify-content: space-between;
}

.alternative-rate-tooltip-body {
  display: flex;
  justify-content: center;
  align-items: flex-start;
  flex-direction: column;
  gap: @space-8;
}

.alternative-rate-tooltip {
  display: flex;
  flex-direction: row;
  gap: @space-8;

  padding: @space-16;
}

.alternative-rate-applied-tooltip-body {
  display: flex;
  align-items: center;
  gap: @space-16;
  justify-content: space-between;
  padding: @space-8;
  background: var(--pine-green-800);
}

.savings-applied-body {
  display: flex;
  align-items: center;
  gap: @space-4;
  justify-content: flex-end;
}

.savings-applied-icon {
  width: 16px;
  height: 16px;
  display: flex;
}

.help-link {
  color: var(--primary--link--text-color--5);
  &:hover {
    color: var(--primary--link--text-color--5);
    text-decoration: underline;
  }
}
